import React, { useContext, useEffect, useState } from 'react';
import { Grid, Box, Divider, Typography } from '@mui/material';

import axiosInstance from '../../api';
import SERVER_API_URL from '../../config';
import { authContext } from '../../routes';
import StyledCardNoHeight from '../../components/card/StyledCardNoHeight';
import { ethDate } from '../../utils/ethDate';

export default function Guarantor() {
  const { user } = useContext(authContext);
  const [guarantor, setGuarantor] = useState();
   console.log('user::::', user)
  useEffect(() => {
    const getUserGuarantor = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/user/findOneGuarantorByUserId/${user && user.id}`);
        if (response.status === 200) {
          setGuarantor(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getUserGuarantor();
  }, [user]);

  return (
    <StyledCardNoHeight sx={{ p: 2 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ color: 'darkgray' }}>
            የዋስትና ተጠሪ
          </Typography>
        </Grid>
        {guarantor && (
          <Grid item xs={12} sm={6}>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {guarantor && ethDate(guarantor.updatedAt)}
                : የተስተካከለበት ቀን
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {guarantor && ethDate(guarantor.createdAt)}
                : የተመዘገበበት ቀን
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>

      <Divider sx={{ mt: 2, mb: 2, borderStyle: 'dashed' }} />

      {guarantor && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              ስም :
            </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.firstName}{' '} {guarantor && guarantor.lastName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>ስራ : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.job}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}> የስልክ ቁጥር : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.phone}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>ጾታ : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.gender}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}> ወረዳ : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.church.district.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}> አጥቢያ : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.church.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}> ምድብ : </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {guarantor && guarantor.category.name}
            </Typography>
          </Grid>
        </Grid>
      )}
      {!guarantor && <Box sx={{ p: 5, pl: '40%' }}>ተጠሪ የሎትም።</Box>}
    </StyledCardNoHeight>
  );
}
